export const ELECTRIC_HEATED_SEATS = 21;
export const ELECTRIC_SIDE_MIRROR = 100;
export const ELECTRIC_WINDOWS = 130;
export const HEAD_UP_DISPLAY = 80;
export const ISOFIX = 61;
export const MULTIFUNCTION_STEERING_WHEEL = 106;
export const ON_BOARD_COMPUTER = 127;
